import React from "react";

const GOOGLE_MAPS_EMBED_URL =
  "https://www.google.com/maps?q=84+Aleksandar+Stamboliyski+Blvd,+Sofia,+Bulgaria&z=17&output=embed";

export function ContactMapGoogle(): React.ReactElement {
  return (
    <div className="w-full h-[280px] rounded-lg overflow-hidden border border-gray-200 bg-gray-100">
      <iframe
        title="BalkanFinXpert – адрес на карта"
        src={GOOGLE_MAPS_EMBED_URL}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="w-full h-full"
      />
    </div>
  );
}

export default ContactMapGoogle;
